import React, { useState } from 'react';
import { Typography, CardContent, Box, Stack } from '@mui/material';
import { SidebarCard, styles } from './styles';
import { DocTypeIcon } from '../Components/Utilities';
import FilePreviewModal from '../Components/Modals/FilePreviewModal';
import { styles as applicationStyles } from '../Application/styles';
import { IAsset } from './types';
import { IJobAttachment } from '../Components/Modals/FilePreviewModal';

export default function Documents({ assets }: { assets: IAsset[] }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState<IJobAttachment | null>(null);

  const handleOpenPreview = (asset: IAsset) => {
    const jobAttachment: IJobAttachment = {
      id: asset.id,
      attached_file_name: asset.attached_file_name,
      attached_content_type: 'application/pdf',
      created_at: '',
      url: asset.url,
      application_link: asset.application_link
    };
    setSelectedAsset(jobAttachment);
    setPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setSelectedAsset(null);
  };

  if (!assets || assets.length === 0) {
    return (
      <SidebarCard>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
            Documents
          </Typography>
          <Box sx={applicationStyles.noAttachments}>
            <Typography variant="body2" sx={{ color: '#999' }}>
              No documents available
            </Typography>
          </Box>
        </CardContent>
      </SidebarCard>
    );
  }

  return (
    <>
      <SidebarCard>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
            Documents
          </Typography>
          <Stack direction="column" spacing={1}>
            {assets.map((asset) => {
              const fileFormat = asset.attached_file_name.split('.').pop();
              return (
                <Stack key={asset.id} direction="row" spacing={1}>
                  <Box sx={applicationStyles.fileIconContainer}>
                    <Box sx={applicationStyles.fileIcon} onClick={() => handleOpenPreview(asset)}>
                      {DocTypeIcon(fileFormat)}
                    </Box>
                    <Box>
                      <Box sx={applicationStyles.fileName} onClick={() => handleOpenPreview(asset)}>
                        {asset.attached_file_name}
                      </Box>
                    </Box>
                  </Box>
                </Stack>
              );
            })}
          </Stack>
        </CardContent>
      </SidebarCard>
      {selectedAsset && (
        <FilePreviewModal
          previewOpen={previewOpen}
          setPreviewOpen={handleClosePreview}
          selectedAttachment={selectedAsset}
          isShareable={false}
          applicationLink={selectedAsset.application_link}
          allowDownload={true}
        />
      )}
    </>
  );
}
